<button
  #backdrop
  type="button"
  class="app-bottom-sheet__backdrop absolute inset-0 z-0 m-0 border-0 bg-black/30 p-0 opacity-0 pointer-events-none appearance-none cursor-default outline-none focus:outline-none focus-visible:outline-none [-webkit-tap-highlight-color:transparent] motion-reduce:transition-none"
  data-testid="content-panel-backdrop"
  tabindex="-1"
  [attr.aria-label]="backdropAriaLabel"
  (click)="onBackdropClick()">
</button>

<section
  #surface
  [class]="surfaceClasses">

  <div
    #handle
    class="app-bottom-sheet__handle z-1 flex w-full shrink-0 cursor-grab touch-none items-center justify-center rounded-t-2xl border-0 bg-inherit py-2 pt-2 pb-1 min-h-6 active:cursor-grabbing"
    role="button"
    tabindex="0"
    [attr.aria-expanded]="state === 'expanded'"
    [attr.aria-label]="handleAriaLabel"
    data-testid="content-panel-drag-handle"
    (keydown.enter)="onHandleActivate($event)"
    (keydown.space)="onHandleActivate($event)">

    <span class="app-bottom-sheet__handle-pill block h-1 w-8 rounded-full bg-outline-variant"></span>
  </div>

  <div class="app-bottom-sheet__content flex min-h-0 flex-1 flex-col overflow-hidden">
    <ng-content />
  </div>
</section>
